import { Container } from "@mui/material";
import React from "react";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";

const AddUserManually = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <Container maxWidth="sm">
        <PageTitle>Add User for ES</PageTitle>
      </Container>
    </Container>
  );
};

export default AddUserManually;
